import { JourneyInterface, QuestInterface, QuestType, RoleInterface, RoleInterfaceMap, Slug } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK apps/server/src/API/Push/Push.Controller.ts
export class PushAPI {
  static async subscribe(orgId: number, memberId: number, data: PushSubscription) {
    return APIService.Server.post<PushSubscription>(`/push/org/${orgId}/member/${memberId}/subscribe`, data);
  }
  static async unsubscribeFromAll(orgId: number, memberId: number) {
    return APIService.Server.post<void>(`/push/org/${orgId}/member/${memberId}/unsubscribe`);
  }
  static async sendPush(
    orgId: number,
    memberId: number,
    payload: {
      title?: string;
      body?: string;
      url?: string;
      tag?: string;
    }
  ) {
    return APIService.Server.post<void>(`/push/org/${orgId}/member/${memberId}/send`, payload);
  }
  static async getSubscriptionObjects(orgId: number, memberId: number) {
    return APIService.Server.get<PushSubscription[] | null>(`/push/org/${orgId}/member/${memberId}/subscription`);
  }
  static async testPush(orgId: number, memberId: number) {
    return APIService.Server.post<void>(`/push/org/${orgId}/member/${memberId}/test`);
  }
}
